import { useState } from "react";
import { toast } from "sonner";
import { ExternalLink, Copy, Check, Globe, AlertTriangle } from "lucide-react";

const origin = () => window.location.origin.replace(/\/$/, "");

export const PageStrip = ({ profile }) => {
  const [copied, setCopied] = useState(false);
  if (!profile?.slug) return null;

  const url = `${origin()}/${profile.slug}`;
  const pretty = url.replace(/^https?:\/\//, "");
  const hasApply = !!(profile.apply_url || "").trim();
  const states = profile.licensed_states || [];

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Your page link is copied");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="rounded-3xl bg-navy text-white shadow-soft px-6 sm:px-8 py-5 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6"
      data-testid="mlo-page-strip"
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-lime">
          <Globe size={12} /> Your page is live
        </div>
        <p className="mt-1 font-heading font-medium text-xl sm:text-2xl truncate" data-testid="mlo-page-strip-url">
          {pretty}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-white/70">
          <span>
            {profile.accepting_leads ? "Accepting leads from the main page" : "Not accepting leads from the main page"}
          </span>
          {states.length > 0 && <span>· Licensed in {states.join(", ")}</span>}
          {!hasApply && (
            <span className="inline-flex items-center gap-1 text-amber-300">
              <AlertTriangle size={11} /> No application link set — Apply buttons say “Call” instead
            </span>
          )}
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2 shrink-0">
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          data-testid="mlo-page-strip-view"
          className="inline-flex items-center gap-2 bg-lime text-navy font-semibold text-sm px-5 py-2.5 rounded-full hover:brightness-95 transition-all"
        >
          View my page <ExternalLink size={14} />
        </a>
        <button
          type="button"
          onClick={copy}
          data-testid="mlo-page-strip-copy"
          className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-sm px-5 py-2.5 rounded-full transition-colors"
        >
          {copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
};

export default PageStrip;
